import { translate, translateLKMessage } from './helpers'

export const ADD_MODAL = 'UCCPayFormModal'
export const CLIENT_SEARCH_NAME = 'UCCPayFormClientSearch'
export const CLIENT_CONFIRM_MODAL = 'UCCPayFormClientConfirmModal'
export const CONFIRM_LAST_PAYMENTS = 'UCCPayFormLastPaymentsConfirmModal'
export const CONFIRM_PAY_MODAL = 'UCCPayFormPayConfirmModal'

export const ORDER_MODAL = 'UCC_ORDER_VIEW'
export const paymentTypes = [
  { value: 'payments', label: translate('Payments') },
  { value: 'checks', label: translate('Checks') },
]
export const SELECT_CLIENT = translate('lbl_select_client')
export const ERR_REQUIRED_FIELD = translateLKMessage('ERR_REQUIRED_FIELD')
export const CLIENT_EDIT = 'ClientEditInUCCPayForm'
export const CLIENT_GROUP_ID = 6
